import { AccountSlideout } from '@juvare/contact-management/ui/features/accounts';
import { ParticipantDetailsComponentProps } from '@juvare/missions/ui/providers';
import React from 'react';
import { RmsAccountDetailsComponent } from '../../accounts';

export const ParticipantDetailsComponent = ({
    participantId,
    onParticipantIdReset,
    slideoutMenuItems,
}: ParticipantDetailsComponentProps) => {
    if (!onParticipantIdReset) {
        return null;
    }

    return (
        <AccountSlideout
            onClose={onParticipantIdReset}
            accountId={participantId}
            customDetailsComponent={(props) => (
                <RmsAccountDetailsComponent {...props} onClose={onParticipantIdReset} menuItems={slideoutMenuItems} />
            )}
        />
    );
};
